var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAuto(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 41.655,
    height: 40,
    viewBox: "0 0 41.655 40",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "car",
    transform: "translate(0.75 0.75)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_91190",
    "data-name": "Path 91190",
    d: "M13.052,2.08H27.1c2.523,0,4.347.611,5.574,1.867a8.362,8.362,0,0,1,1.949,4.3l2.262,10.83a.815.815,0,0,1-.8.982H4.065a.815.815,0,0,1-.8-.982L5.529,8.253A8.364,8.364,0,0,1,7.478,3.947C8.706,2.691,10.529,2.08,13.052,2.08ZM35.086,18.432,33.03,8.586a6.956,6.956,0,0,0-1.519-3.5c-.9-.926-2.347-1.376-4.408-1.376H13.052c-2.061,0-3.5.45-4.408,1.376a6.958,6.958,0,0,0-1.519,3.5L5.069,18.432Z",
    transform: "translate(0.001 -2.83)",
    fill: "#09143a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_91191",
    "data-name": "Path 91191",
    d: "M38.011,33.9H34.249c-2.743,0-3.225-1.446-3.612-2.609l-.411-1.232c-.538-1.575-.739-2.164-3.022-2.164H16.955a3.24,3.24,0,0,0-2.235.586,3.836,3.836,0,0,0-.794,1.6l-.4,1.211c-.387,1.162-.869,2.609-3.612,2.609H6.147a4.94,4.94,0,0,1-3.648-1.6,4.775,4.775,0,0,1-1.226-3.652L2.393,16.455a7.527,7.527,0,0,1,1.38-4.309c1.091-1.293,2.85-1.9,5.537-1.9H34.849c2.687,0,4.446.6,5.537,1.9a7.525,7.525,0,0,1,1.379,4.308l1.121,12.19a4.774,4.774,0,0,1-1.227,3.65A4.94,4.94,0,0,1,38.011,33.9ZM16.955,26.262H27.2c3.45,0,3.992,1.587,4.566,3.268l.009.026,0,.006.4,1.211a2.745,2.745,0,0,0,.539,1.116,2.25,2.25,0,0,0,1.526.377h3.763a3.306,3.306,0,0,0,2.443-1.07,3.1,3.1,0,0,0,.809-2.4L40.142,16.6c-.274-2.939-.767-4.723-5.293-4.723H9.31c-4.525,0-5.018,1.785-5.293,4.725L2.9,28.793A3.1,3.1,0,0,0,3.7,31.2a3.306,3.306,0,0,0,2.443,1.07H9.91a2.25,2.25,0,0,0,1.526-.377,2.744,2.744,0,0,0,.539-1.116l.4-1.211C12.895,28.015,13.479,26.262,16.955,26.262Z",
    transform: "translate(-2.001 5.353)",
    fill: "#09143a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_91192",
    "data-name": "Path 91192",
    d: "M5.067,8.881h-2a.815.815,0,1,1,0-1.631h2a.815.815,0,1,1,0,1.631Z",
    transform: "translate(-1.001 2.348)",
    fill: "#09143a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_91193",
    "data-name": "Path 91193",
    d: "M22.067,8.881h-2a.815.815,0,1,1,0-1.631h2a.815.815,0,1,1,0,1.631Z",
    transform: "translate(16.025 2.348)",
    fill: "#09143a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_91194",
    "data-name": "Path 91194",
    d: "M12.065,7.884a.815.815,0,0,1-.815-.815v-4a.815.815,0,0,1,1.631,0v4A.815.815,0,0,1,12.065,7.884Z",
    transform: "translate(8.013 -2.66)",
    fill: "#09143a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_91195",
    "data-name": "Path 91195",
    d: "M16.57,5.881h-6a.815.815,0,0,1,0-1.631h6a.815.815,0,0,1,0,1.631Z",
    transform: "translate(6.51 -0.657)",
    fill: "#09143a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_91196",
    "data-name": "Path 91196",
    d: "M12.07,15.881h-6a.815.815,0,0,1,0-1.631h6a.815.815,0,0,1,0,1.631Z",
    transform: "translate(2.004 9.359)",
    fill: "#09143a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_91197",
    "data-name": "Path 91197",
    d: "M21.07,15.881h-6a.815.815,0,1,1,0-1.631h6a.815.815,0,1,1,0,1.631Z",
    transform: "translate(11.017 9.359)",
    fill: "#09143a"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAuto);
export default __webpack_public_path__ + "static/media/Auto.e799d26faff4b39ab81a470212520486.svg";
export { ForwardRef as ReactComponent };